<template>
    <div class="ui fixed inverted main menu">
        <div class="ui container">
            <div class="item logoitem" style="padding-top: 5px; padding-bottom: 5px">
                <a class="ui logo icon image" href="/" style="width:60px">
                    <img src="@assets/images/Logo_TecNM_Horizontal_Blanco.svg" />
                </a>
            </div>
            <div class="item logoitem" style="padding-top: 5px; padding-bottom: 5px">
                <a class="ui logo icon image" href="/">
                    <img src="@assets/images/logo_TECT.png" />
                </a>
            </div>
            <div class="right menu">
                <div class="ui simple dropdown item">
                    {{ oidcUser ? oidcUser.name : 'Usuario' }}
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <!-- <a href class="item" @click.prevent="perfil">Perfil</a>
                        <div class="divider"></div> -->
                        <a href class="item" @click.prevent="signOut">Cerrar sesión</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Urls from '@constants';

export default {
	components: {},
	data() {
		return {};
	},
	computed: {
		...mapGetters('menu', ['isOpen','getAnimation']),
		...mapGetters('oidc', ['oidcUser']),
    },
    watch: {
      isOpen: function () {
        setTimeout(() => {
          this.setAnimation(false);
        }, 1000);
      }
    },
	methods: {
		...mapActions('menu', ['changeOpen','setAnimation']),
		...mapActions('oidc', ['removeOidcUser']),
		signOut: function() {
			this.removeOidcUser().then(() => {
				window.location =
					Urls.URL_AUTH + 'Account/Logout?redirectUrl=' + Urls.URL_APP;
			});
        },
        open: function($event) {
			this.setAnimation(true);
			$event.stopPropagation();
			this.changeOpen(true);
		},
		close: function($event) {
			this.setAnimation(true);
			this.changeOpen(false);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';

.marginlefting {
	width: calc(100% - 60px) !important;
	margin-left: 60px !important;
}

.bgnavbar {
	background: $background-color-navbar !important;
	// background: #213f6f !important;
}
.heightNavBar {
	height: 48px;
}
</style>
